const currency = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
const count = new Intl.NumberFormat("en-US");

export function formatCurrency(value: number): string {
    return currency.format(value);
}

export function formatCount(value: number): string {
    return count.format(value);
}

export function formatTime(value: string | null): string {
    return value === null ? "" : value.slice(11, 16);
}

export function formatTimeRange(begin: string | null, end: string | null): string {
    const from = formatTime(begin);
    const to = formatTime(end);
    return to === "" ? from : `${from}-${to}`;
}

export function parseIsoDate(value: string): Date {
    const [year, month, day] = value.slice(0, 10).split("-").map(Number);
    return new Date(year ?? 1970, (month ?? 1) - 1, day ?? 1);
}

export function toIsoDate(date: Date): string {
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${date.getFullYear()}-${month}-${day}`;
}

export function formatLongDate(value: string | null): string {
    if (value === null) {
        return "";
    }
    return new Date(value).toLocaleDateString("en-US", {
        weekday: "long",
        month: "short",
        day: "numeric",
        year: "numeric",
    });
}

export function formatShortDate(value: string | null): string {
    if (value === null) {
        return "";
    }
    return new Date(value).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
    });
}
